import {useTranslation} from "react-i18next"

import {ErrorPage} from "~/components/ErrorPage"

export const action = async () => {
  // Handle POSTs to this catch-all route to avoid errors that make
  // their way to Sentry when bots make random POST requests to
  // various URLs.
}

export default function NotFound() {
  const {t} = useTranslation()

  return (
    <ErrorPage
      heading={t("errors.notFound.heading")}
      details={t("errors.notFound.details")}
      homeButtonTitle={t("errors.homeButtonTitle")}
    />
  )
}
